import { Skeleton, Table } from '@radix-ui/themes';
import { range } from 'lodash';

export const TableBodyLoading = (props: {
  rows: number;
  visibleColumns: number;
  rowClasses: string | undefined;
}) => {
  const rowCt = range(0, props.rows);
  const visibleColCt = range(0, props.visibleColumns);

  return (
    <Table.Body>
      {rowCt.map((r, iR) => (
        <Table.Row key={`skeleton-${iR}`} className={props.rowClasses}>
          {visibleColCt.map((c, iC) => (
            <Table.Cell key={`skeleton-${iR}-${iC}`}>
              <Skeleton />
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </Table.Body>
  );
};
